import OverviewsIcon from "./OverviewsIcon";
import ArrowIcon from "./ArrowIcon";
import ListVideoIcon from "./ListVideoIcon";
import NewsLIcon from "./NewsLIcon";
import LibraryIcon from "./LibraryIcon";
import ArrowIconMenuCollapse from "./ArrowIconMenuCollapse";
import CloseIcon from "./CloseIcon";
import CloseEyePasswordIcon from "./CloseEyePasswordIcon";
import LockIcon from "./LockIcon";
import OpenEyePasswordIcon from "./OpenEyePasswordIcon";
import UserLoginIcon from "./UserLoginIcon";
import EditIcon from "./EditIcon";
import SearchIcon from "./SearchIcon";
import ThreeDotIcon from "./ThreeDotIcon";
import DeleteIcon from "./DeleteIcon";
import UploadIcon from "./UploadIcon";
import CheckedIconOrgSelect from "./CheckedIconOrgSelect";
import MinusSquare from "./MinusSquare";
import PlusSquare from "./PlusSquare";
import WarningNotifyIcon from "./WarningNotifyIcon";
import ClearFilterIcon from "./ClearFilterIcon";
import FilterIcon from "./FilterIcon";
import DotSquare from "./DotSquare";
import PlusIcon from "./PlusIcon";
import DocumentIcon from "./DocumentIcon";

//Icon view finish
import PublisherIcon from "./PublisherIcon";
import CalendarIcon from "./CalendarIcon";
import BookTypeIcon from "./BookTypeIcon";
import SubjectIcon from "./SubjectIcon";
import ClassIcon from "./ClassIcon";
import LanguageIcon from "./LanguageIcon";

// Group create Icon
import BookIcon from "./groupCreate/BookIcon";
import MessageQuestionIcon from "./groupCreate/MessageQuestionIcon";
import ReportMedicalIcon from "./groupCreate/ReportMedicalIcon";
import MatrixIcon from "./groupCreate/MatrixIcon";
import LessonIcon from "./groupCreate/LessonIcon";
import DesktopQuestion from "./groupCreate/DesktopQuestion";
import FilePlusIcon from "./groupCreate/FilePlusIcon";
import CloudQuestionIcon from "./groupCreate/CloudQuestionIcon";
import ScreenShareIcon from "./groupCreate/ScreenShareIcon";
import PermutationIcon from "./groupCreate/PermutationIcon";

//Icon menu document
import PaperIcon from "./PaperIcon";
import AudioIcon from "./AudioIcon";
import AlbumIcon from "./AlbumIcon";
import OtherDocumentIcon from "./OtherDocumentIcon";
import VideoIcon from "./VideoIcon";
import SkillIcon from "./SkillIcon";

import ArrowLeftIcon from "./ArrowLeftIcon";
import ArrowRightIcon from "./ArrowRightIcon";
import DateIcon from "./DateIcon";
import ViewTableIcon from "./ViewTableIcon";
import ViewGridIcon from "./ViewGridIcon";
import UserIcon from "./UserIcon";
import MenuIcon from "./MenuIcon";
import NotifyIcon from "./NotifyIcon";
import LogoutIcon from "./LogoutIcon";
import PasswordIcon from "./PasswordIcon";
import WindowIcon from "./WindowIcon";
import SuccessIcon from "./SuccessIcon";
import RadioDefaultIcon from "./RadioDefaultIcon";
import RadioCheckedIcon from "./RadioCheckedIcon";
import HelperIcon from "./HelperIcon";
import FileTabIcon from "./FileTabIcon";
import CommentIcon from "./CommentIcon";
import CheckBoxIcon from "./CheckBoxIcon";
import CheckBoxOutlineBlankIcon from "./CheckBoxOutlineBlankIcon";
import ResetIcon from "./ResetIcon";
import AttachIcon from "./file/AttachIcon";
import DocxIcon from "./file/DocxIcon";
import ExcelIcon from "./file/ExcelIcon";
import FileByType from "./file/FileByType";
import FullScreenIcon from "./FullScreenIcon";
import FileIcon from "./file/FileIcon";
import GifIcon from "./file/GifIcon";
import ImageIcon from "./file/ImageIcon";
import Mp3Icon from "./file/Mp3Icon";
import Mp4Icon from "./file/Mp4Icon";
import PdfIcon from "./file/PdfIcon";
import PowPointIcon from "./file/PowPointIcon";
import ZipIcon from "./file/ZipIcon";
import MinusFillSquare from "./MinusFillSquare";
import DiagonalArrowIcon from "./DiagonalArrowIcon";
import StatisticalIcon from "./StatisticalIcon";
import HexagonIcon from "./HexagonIcon";
import WindowPlusIcon from "./WindowPlusIcon";
import StudentHatIcon from "./StudentHatIcon";
import DateClockIcon from "./DateClockIcon";
import FolderQuestionIcon from "./FolderQuestionIcon";
import DeviceDesktopStarIcon from "./DeviceDesktopStarIcon";
import CheckboxMissAngleIcon from "./CheckboxMissAngleIcon";
import TelevisionIcon from "./TelevisionIcon";
import CloudSearchIcon from "./CloudSearchIcon";
import ColumnThreeIcon from "./ColumnThreeIcon";
import InfoHexagonIcon from "./InfoHexagonIcon";
import DetailIcon from "./DetailIcon";
import DotVerticalIcon from "./DotVerticalIcon";
import FilterAdvancedIcon from "./FilterAdvancedIcon";
import CheckedFillIcon from "./CheckedFillIcon";
import RequiredIcon from "./RequiredIcon";
import ArrowDownUpIcon from "./ArrowDownUpIcon";
import DownloadIcon from "./DownloadIcon";
import ArrowSelectIcon from "./ArrowSelectIcon";
import ChangePasswordIcon from "./ChangePasswordIcon";

export {
  RequiredIcon,
  PermutationIcon,
  ScreenShareIcon,
  CloudQuestionIcon,
  FilePlusIcon,
  DesktopQuestion,
  LessonIcon,
  MatrixIcon,
  ReportMedicalIcon,
  MessageQuestionIcon,
  BookIcon,
  HexagonIcon,
  StatisticalIcon,
  DiagonalArrowIcon,
  FullScreenIcon,
  DotSquare,
  WarningNotifyIcon,
  SuccessIcon,
  UploadIcon,
  MinusSquare,
  PlusSquare,
  OverviewsIcon,
  ArrowIcon,
  ListVideoIcon,
  NewsLIcon,
  LibraryIcon,
  SearchIcon,
  ArrowIconMenuCollapse,
  CloseIcon,
  CloseEyePasswordIcon,
  LockIcon,
  ChangePasswordIcon,
  OpenEyePasswordIcon,
  UserLoginIcon,
  EditIcon,
  ThreeDotIcon,
  DeleteIcon,
  CheckedIconOrgSelect,
  ClearFilterIcon,
  FilterIcon,
  PlusIcon,
  DocumentIcon,
  AttachIcon,
  DocxIcon,
  ExcelIcon,
  PowPointIcon,
  PdfIcon,
  Mp3Icon,
  Mp4Icon,
  ZipIcon,
  GifIcon,
  ImageIcon,
  FileIcon,
  FileByType,
  ResetIcon,
  PaperIcon,
  AudioIcon,
  AlbumIcon,
  OtherDocumentIcon,
  VideoIcon,
  SkillIcon,
  PublisherIcon,
  CalendarIcon,
  BookTypeIcon,
  SubjectIcon,
  ClassIcon,
  LanguageIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  DateIcon,
  ViewTableIcon,
  ViewGridIcon,
  UserIcon,
  MenuIcon,
  NotifyIcon,
  LogoutIcon,
  PasswordIcon,
  WindowIcon,
  RadioCheckedIcon,
  RadioDefaultIcon,
  FileTabIcon,
  HelperIcon,
  CommentIcon,
  CheckBoxIcon,
  CheckBoxOutlineBlankIcon,
  MinusFillSquare,
  WindowPlusIcon,
  StudentHatIcon,
  DateClockIcon,
  FolderQuestionIcon,
  DeviceDesktopStarIcon,
  CheckboxMissAngleIcon,
  CloudSearchIcon,
  TelevisionIcon,
  ColumnThreeIcon,
  InfoHexagonIcon,
  DetailIcon,
  DotVerticalIcon,
  FilterAdvancedIcon,
  CheckedFillIcon,
  ArrowDownUpIcon,
  DownloadIcon,
  ArrowSelectIcon,
};
